import { CardContent } from "@mui/material";
import { styled } from "@mui/system";

const LoaderWrapper = styled("div")(() => ({
  color: "rgb(124, 124, 124)",
  fontFamily: "Poppins, sans-serif",
  fontWeight: 500,
  fontSize: "18px",
  height: "30px",
  padding: "10px 10px",
  display: "flex",
  borderRadius: "8px",
  alignItems: "center",
}));

const Words = styled("div")({
  overflow: "hidden",
  position: "relative",
  height: "100%",
});

const Word = styled("span")({
  display: "block",
  paddingLeft: "6px",
  color: "grey",
  animation: "spin 15s infinite",
  "@keyframes spin": {
    "0%": { transform: "translateY(0%)" },
    "20%": { transform: "translateY(0%)" },

    "25%": { transform: "translateY(-100%)" },
    "40%": { transform: "translateY(-100%)" },

    "45%": { transform: "translateY(-200%)" },
    "60%": { transform: "translateY(-200%)" },

    "65%": { transform: "translateY(-300%)" },
    "80%": { transform: "translateY(-300%)" },

    "85%": { transform: "translateY(-400%)" },
    "100%": { transform: "translateY(-400%)" },
  },
});

export default function AnimatedLoader() {
  return (
    <CardContent sx={{ p: 0 }}>
      <LoaderWrapper>
        <Words>
          <Word>
            Justtawk connects businesses with customers through real-time chat
            support.
          </Word>
          <Word>
            Engage visitors instantly with chatbots and live agents on your
            website.
          </Word>
          <Word>
            Track conversations, manage leads, and boost sales with Justtawk
            tools.
          </Word>
          <Word>
            Simplify customer support by integrating chat across multiple
            platforms.
          </Word>
          <Word>
            Justtawk helps you build stronger customer relationships with ease.
          </Word>
        </Words>
      </LoaderWrapper>
    </CardContent>
  );
}
